module.exports = __webpack_public_path__ + "img/client_logo_3.5d3e6b01.png";